<template>
	<div class="view-content">
		<div class="view-content-info">
			<div class="user-login">
				<div class="user-login-title"><a href="/">首页</a> / <span>新用户注册</span></div>
				<div class="user-login-content">
					<div class="register-content-title" v-if="step == 1">新用户注册 </div>
					
					<div class="register-content-form" v-if="step == 1">
						<el-form :model="ruleForm" :rules="rules" ref="oneForm" label-width="0px">
						  <el-form-item label="" prop="account" label-width="0px">
								<div class="flex-start flex-center">
									<div class="title-label flex-start flex-center"><img src="@/assets/images/restier/account.png"/>账号</div>
									<el-input v-model="ruleForm.account" placeholder="设置账号"></el-input>
								</div>
						  </el-form-item>
						  <el-form-item label="" prop="password" label-width="0px">
								<div class="flex-start flex-center">
									<div class="title-label flex-start flex-center"><img src="@/assets/images/restier/pwd.png"/>登录密码</div>
									<el-input v-model="ruleForm.password" type="password" placeholder="设置6至20位登录密码"></el-input>
								</div>
						  </el-form-item>
						  <el-form-item label="" prop="confirmPassword" label-width="0px">
								<div class="flex-start flex-center">
									<div class="title-label flex-start flex-center"><img src="@/assets/images/restier/pwd.png"/>登录密码</div>
									<el-input v-model="ruleForm.confirmPassword" type="password" placeholder="请再次输入登录密码"></el-input>
								</div>
						  </el-form-item>
						  <el-form-item label="" prop="phone" label-width="0px">
								<div class="flex-start flex-center">
									<div class="title-label flex-start flex-center"><img src="@/assets/images/restier/phone.png"/>手机号</div>
									<el-input v-model="ruleForm.phone" placeholder="输入手机号码"></el-input>
								</div>
						  </el-form-item>
						  <el-form-item label="" prop="code" label-width="0px">
								<div class="flex-start flex-center">
									<div class="title-label flex-start flex-center"><img src="@/assets/images/restier/code.png"/>验证码</div>
									<el-input v-model="ruleForm.code" placeholder="短信验证码">
										<div slot="suffix" class="send-code" v-if="send">{{time}}S</div>
										<div slot="suffix" class="send-code" v-else @click="sendCode">获取验证码</div>
									</el-input>
								</div>
						  </el-form-item>
						  
						</el-form>
						
						<el-button class="login-button" type="primary" :loading="false" @click="oneSubmit()">下一步</el-button>
					</div>
					
					
					<div class="register-two-form" v-if="step == 2">
						
						<el-form :model="ruleForm" :rules="rules" ref="ruleTwoForm" label-position="right" label-width="160px">
							
							<div class="register-two-form-title">基本信息 </div>
							  <el-row :gutter="20">
								<el-col :span="12">
									<el-form-item label="统一社会信用代码" prop="creditCode">
										<el-input class="register-two-form-input" v-model="ruleForm.creditCode" placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="企业名称" prop="companyName">
										<el-input class="register-two-form-input" v-model="ruleForm.companyName" placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="企业法人" prop="legalPerson">
										<el-input class="register-two-form-input" v-model="ruleForm.legalPerson" placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="详细地址" prop="companyAddress">
										<el-input class="register-two-form-input" v-model="ruleForm.companyAddress" placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="营业执照" prop="businessLicense">
										<el-upload :action="$apiBase + '/system/upload'" ref="uploadFile" :on-success="successImage" :limit="1">
											<div v-if="ruleForm.businessLicense" class="image-list-item">
												<img :src="ruleForm.businessLicense"/>
											</div>
											<div v-else class="image-list-add">
												<img src="@/assets/images/add2.png"/>
												<div>选择图片</div>
											</div>
										</el-upload>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="其他资料" prop="additionalImage">
										<el-upload :action="$apiBase + '/system/upload'" ref="additionalImageFile" :on-success="successAdditionalImage" :limit="1">
											<div v-if="ruleForm.additionalImage" class="image-list-item">
												<img :src="ruleForm.additionalImage"/>
											</div>
											<div v-else class="image-list-add">
												<img src="@/assets/images/add2.png"/>
												<div>选择图片</div>
											</div>
										</el-upload>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="法人身份证正面" prop="frontImage">
										<el-upload :action="$apiBase + '/system/upload'" ref="frontImageFile" :on-success="successFrontImage" :limit="1">
											<div v-if="ruleForm.frontImage" class="image-list-item">
												<img :src="ruleForm.frontImage"/>
											</div>
											<div v-else class="image-list-add">
												<img src="@/assets/images/add2.png"/>
												<div>选择图片</div>
											</div>
										</el-upload>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="法人身份证反面" prop="backImage">
										<el-upload :action="$apiBase + '/system/upload'" ref="backImageFile" :on-success="successBackImage" :limit="1">
											<div v-if="ruleForm.backImage" class="image-list-item">
												<img :src="ruleForm.backImage"/>
											</div>
											<div v-else class="image-list-add">
												<img src="@/assets/images/add2.png"/>
												<div>选择图片</div>
											</div>
										</el-upload>
									</el-form-item>
								</el-col>
							  </el-row>
							  
							<div class="register-two-form-title">联系人信息 </div>
							
							
							  <el-row :gutter="20">
								<el-col :span="12">
									<el-form-item label="联系人姓名" prop="contactName">
										<el-input class="register-two-form-input" v-model="ruleForm.contactName" placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
								<el-col :span="12">
									<el-form-item label="联系人电话" prop="contactPhone">
										<el-input class="register-two-form-input" v-model="ruleForm.contactPhone" placeholder="请输入"></el-input>
									</el-form-item>
								</el-col>
							  </el-row>
						</el-form>
						
						<el-button class="login-button" type="primary" :loading="siLoad" @click="submitForm()">下一步</el-button>
						
						
						<div class="register-label flex-midden flex-center" @click="is_agree = !is_agree">
							<img v-if="is_agree" src="@/assets/images/radio.png"/>
							<img v-else src="@/assets/images/no-radio.png"/>
							<div>已阅读并同意<span @click.stop="toAgree" target="_blank">《用户服务协议》</span></div>
						</div>
					</div>
					
					<div v-if="step == 3">
						<div class="register-three">
							<img src="@/assets/images/dui.png"/>
							<div class="register-three-title">提交成功</div>
							<div class="register-three-desc">管理员审核中</div>
							<div class="register-three-button" @click="toIndex">进入首页</div>
						</div>
					</div>
					
				</div>
			</div>
	
		</div>
	</div>
</template>

<script>
	import {smsCode,register} from "@/api/login"
	export default {
		data(){
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
				  callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.password) {
				  callback(new Error('两次输入密码不一致!'));
				} else {
				  callback();
				}
			};
			var validatePhone = (rule, value, callback) => {
				if (value === '') {
				  callback(new Error('请输入手机号'));
				} else if (!/^1\d{10}$/.test(value)) {
				  callback(new Error('请输入正确的手机号'));
				} else {
				  callback();
				}
			};
			var validatePass = (rule, value, callback) => {
				if (value === '') {
				  callback(new Error('请输入登录密码'));
				  
				} else if (!/^(?=.*\d)(?=.*[a-zA-Z])[\da-zA-Z~!@#$%^&*.]{6,20}$/.test(value)) {
				  callback(new Error('密码必须是6-20位、必须含有字母、数字!'));
				} else {
				  callback();
				}
			};
			return {
				isselect:false,
				ruleForm:{
					account:"",
					phone:"",
					password:"",
					confirmPassword:"",
					code:"",
					creditCode:"",//统一社会信用代码
					companyName:"",//企业名称
					legalPerson:"",//企业法人
					companyAddress:"",//企业地址
					businessLicense:"",//营业执照
					additionalImage:"",//其他资料
					frontImage:"",//身份证正面 
					backImage:"",//身份证反面
					contactPhone:"",//联系人手机号
					contactName:"",//联系人姓名
				},
				rules:{
					account:[
						{ required: true, message: '请输入账号', trigger: 'blur' },
					],
					phone: [
						{ validator: validatePhone, trigger: 'blur' }
					],
					password: [
						{ validator: validatePass, trigger: 'blur' }
					],
					confirmPassword: [
						{ validator: validatePass2, trigger: 'blur' }
					],
					code: [
						{ required: true, message: '请输入验证码', trigger: 'blur' }
					],
					creditCode: [
						{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
					],
					companyName: [
						{ required: true, message: '请输入企业名称', trigger: 'blur' }
					],
					legalPerson: [
						{ required: true, message: '请输入企业法人', trigger: 'blur' }
					],
					companyAddress: [
						{ required: true, message: '请输入企业地址', trigger: 'blur' }
					],
					businessLicense: [
						{ required: true, message: '请上传营业执照', trigger: 'blur' }
					],
					// additionalImage: [
					// 	{ required: true, message: '请上传其他资料', trigger: 'blur' }
					// ],
					frontImage: [
						{ required: true, message: '请上传身份证正面', trigger: 'blur' }
					],
					backImage: [
						{ required: true, message: '请上传身份证反面', trigger: 'blur' }
					],
					contactPhone: [
						{ required: true, message: '请输入联系人手机号', trigger: 'blur' }
					],
					contactName: [
						{ required: true, message: '请输入联系人姓名', trigger: 'blur' }
					],			
				},
				showpwd:false,//是否展示密码
				send:false,
				time:0,
				timeFun:null,
				step:1,
				siLoad:false,//是否提交中
				is_agree:false
			}
		},
		methods:{
			toAgree(){
				window.open("/agree?id=1");
			},
			toIndex(){
				this.$router.replace({name:"index"});
			},
			sendCode(){
				if(this.send){return false;}
				if(this.ruleForm.phone == ""){
					return this.$message.error("请输入手机号");
				}
				let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
				if(!reg.test(this.ruleForm.phone)){
					return this.$message.error("请输入正确的手机号");
				}			
				smsCode({phone:this.ruleForm.phone,type:2}).then(res=>{
					if(res.code == 1000){
						this.send = true;
						this.time = 60;
						this.changeTime();
					}else{
						return this.$message.error(res.message);
					}
				})
				
			},
			changeTime(){
				if(this.timeFun != null){
					clearTimeout(this.timeFun);
				}
				this.timeFun = setTimeout(()=>{
					this.time--;
					if(this.time > 0){
						this.changeTime();
					}else{
						this.send = false;
					}
				},1000);
			},
			oneSubmit(){
				this.$refs['oneForm'].validate((valid) => {
					if (valid) {
						this.step = 2;
					} else {
						return false;
					}
				});
			},
			submitForm(){
				if(this.is_agree == false){
					return this.$message.error("请阅读并同意相关协议");
				}
				this.$refs['ruleTwoForm'].validate((valid) => {
					if (valid) {
						this.siLoad = true;
						register(this.ruleForm).then(res=>{
							if(res.code == 1000){
								this.step = 3;
							}else{
								this.siLoad = false;
								return this.$message.error(res.message);
							}
						})
					} else {
						return false;
					}
				});
			},
			successImage(e){
				if(e.code == 1000){
					this.ruleForm.businessLicense = e.data;
				}
				this.$refs.uploadFile.clearFiles();
			},
			successAdditionalImage(e){
				if(e.code == 1000){
					this.ruleForm.additionalImage = e.data;
				}
				this.$refs.additionalImageFile.clearFiles();
			},
			successFrontImage(e){
				if(e.code == 1000){
					this.ruleForm.frontImage = e.data;
				}
				this.$refs.frontImageFile.clearFiles();
			},
			successBackImage(e){
				if(e.code == 1000){
					this.ruleForm.backImage = e.data;
				}
				this.$refs.backImageFile.clearFiles();
			},
		}
	}
</script>


<style scoped lang="scss">
	.register-three{
		text-align: center;
		padding-top: 160px;
		img{
			width: 64px;
			height: 64px;
		}
		.register-three-title{
			font-size: 18px;
			line-height: 24px;
			color: #070B13;
			margin-top: 20px;
		}
		.register-three-desc{
			font-size: 18px;
			line-height: 24px;
			color: #070B13;
			margin-top: 16px;
		}
		.register-three-button{
			width: 260px;
			height: 46px;
			border: 1px solid rgba(233, 26, 18, 0.1);
			font-size: 16px;
			font-weight: 500;
			line-height: 46px;
			text-align: center;
			color: #070B13;
			margin: 20px auto 0px;
			cursor: pointer;
		}
	}
	.register-label{
		cursor: pointer;
		img{
			width: 16px;
			height: 16px;
		}
		div{
			height: 16px;
			font-size: 12px;
			line-height: 16px;
			color: rgba(9, 18, 31, 0.8);
			span{
				color: #E91A12;
			}

		}
	}
	.register-two-form{
		width: 100%;
	}
	.register-two-form .login-button{
		width: 420px;
		height: 46px;
		border-radius: 4px;
		background: #E91A12;
		border: 0px;
		font-size: 16px;
		color: #FFFFFF;
		margin: 50px auto 20px;
		display: block;
	}
	.register-two-form-title{
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		color: #070B13;
		margin-bottom: 30px;
	}
	.register-two-form ::v-deep .el-input__inner{
		width: 360px;
		height: 40px;
		border: 1px solid rgba(7, 11, 19, 0.1);
		font-size: 16px;
	
	}
	.send-code{
		height: 22px;
		font-weight: 400;
		font-size: 16px;
		color: rgba(233, 26, 18, 1);
		line-height: 22px;
		width: 120px;
		text-align: center;
		position: absolute;
		top: 50%;
		right: 0px;
		margin-top: -11px;
		cursor: pointer;
	}
	
	.register-content-form ::v-deep .el-form-item{
		margin: 0px 0px 16px !important;
	}
	
	.register-content-form ::v-deep .el-button--primary:focus, .el-button--primary:hover{
		background: #E91A12;
		color: #FFFFFF;
	}
	.register-content-form .login-button{
		width: 420px;
		height: 46px;
		border-radius: 4px;
		background: #E91A12;
		border: 0px;
		font-size: 16px;
		color: #FFFFFF;
		margin-left: 108px;
		margin-top: 30px;
	}
	.register-content-form ::v-deep .el-form-item__error{
		top: 50%;
		transform: translate(0%,-50%);
		left: 550px;
	}
	.register-content-form .title-label{
		opacity: 0.6;
		font-size: 16px;
		line-height: 48px;
		color: #070B13;
		flex: 0 0 108px;
		img{
			width: 24px;
			height: 24px;
			margin-right: 8px;
			flex: 0 0 24px;
		}
	}
	.register-content-form ::v-deep .el-form-item{
		margin: 0px 0px 10px;
	}
	.register-content-form ::v-deep .el-input{
		width: 420px;
	}
	.register-content-form ::v-deep .el-input__inner{
		height: 48px;
		border-radius: 0px;
		border: 1px solid rgba(134, 144, 156, 0.3); 
		position: relative;
	
	}
	.user-login-content{
		background: #FFFFFF;
		padding: 20px 40px;
	}
	.register-content-form{
		 margin: 30px 0px 0px 400px;
	}
	.image-list-add{
		width: 106px;
		height: 106px;
		border: 1px dashed rgba(0, 0, 0, 0.4);
		padding: 30px 0px 30px;
		box-sizing: border-box;
		text-align: center;
		margin: 0px 16px 16px 0px;
		img{
			width: 24px;
			height: 24px;
		}
		div{
			font-size: 12px;
			line-height: 16px;
			color: #070B13;
			margin-top: 8px;
		}
	}
	.image-list-item{
		width: 108px;
		height: 108px;
		position: relative;
		margin: 0px 16px 16px 0px;
		img{
			width: 108px;
			height: 108px;
			object-fit: cover;
		}
		.icon-close{
			width: 16px;
			height: 16px;
			position: absolute;
			top: 0px;
			right: 0px;
		}
	}
</style>